/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchConflictName = {
  OperationConflict: "operation_conflict",
  VersionConflict: "version_conflict",
} as const;
export type KillswitchConflictName = ClosedEnum<typeof KillswitchConflictName>;

/** @internal */
export const KillswitchConflictName$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchConflictName
> = z.enum(KillswitchConflictName);
